import React, { useEffect, useState } from "react";
import "App.css";
import { Toaster } from 'sonner';
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import StatsCounterSection from "./components/StatsCounterSection";
import About from "./components/About";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import Projects from "./components/Projects";
import Testimonials from "./components/Testimonials";
import TechnologyPartners from "./components/TechnologyPartners";
import GroupCompanies from "./components/GroupCompanies";
import CTA from "./components/CTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ProjectCategoryPage from "./components/ProjectCategoryPage";
import { getCurrentLocation, navigateTo } from "./utils/navigation";

const HomePage = () => (
  <>
    <Hero />
    <StatsCounterSection />
    <Services />
    <Projects />
    <WhyChooseUs />
    <Testimonials />
    <TechnologyPartners />
    <GroupCompanies />
    <About />
    <CTA />
    <Contact />
  </>
);

function App() {
  const [location, setLocation] = useState(getCurrentLocation());

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const syncLocation = () => {
      setLocation(getCurrentLocation());
    };

    window.addEventListener("popstate", syncLocation);
    window.addEventListener("hashchange", syncLocation);
    return () => {
      window.removeEventListener("popstate", syncLocation);
      window.removeEventListener("hashchange", syncLocation);
    };
  }, []);

  useEffect(() => {
    if (location.pathname !== "/" || !location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }

    const sectionId = location.hash.slice(1);
    const scrollToTarget = () => {
      const target = document.getElementById(sectionId);
      if (target) {
        target.scrollIntoView({ behavior: "auto", block: "start" });
      }
    };

    const timer = window.setTimeout(scrollToTarget, 0);
    return () => window.clearTimeout(timer);
  }, [location]);

  const projectMatch = location.pathname.match(/^\/projects\/([a-z-]+)$/);
  const isHomePage = location.pathname === "/";

  return (
    <div className="App bg-black min-h-screen">
      <Toaster position="top-right" richColors />
      <Navbar />
      {isHomePage ? <HomePage /> : null}
      {projectMatch ? (
        <>
          <ProjectCategoryPage slug={projectMatch[1]} />
          <CTA />
          <Contact />
        </>
      ) : null}
      {!isHomePage && !projectMatch ? (
        <section className="min-h-screen bg-gradient-to-b from-slate-950 via-black to-black pt-32 pb-24">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <p className="text-sm uppercase tracking-[0.24em] text-blue-400">Page Not Found</p>
            <h1 className="mt-4 text-4xl md:text-5xl font-semibold text-white">This page does not exist</h1>
            <p className="mt-6 text-gray-400">
              Return to the homepage to continue exploring our services and project categories.
            </p>
            <button
              type="button"
              onClick={() => navigateTo("/")}
              className="mt-10 inline-flex items-center rounded-md bg-blue-600 px-6 py-3 text-white transition-colors duration-300 hover:bg-blue-700"
            >
              Back to homepage
            </button>
          </div>
        </section>
      ) : null}
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
